export interface FullscreenVideoPreviewItemData {
  url: string;
  thumbUrl: string;
  width: number;
  height: number;
  duration: number;
  hasAudio: boolean;
}

export interface FullscreenVideoPreviewProps<T extends {id: number}> {
  items: T[];
  currentItemId: number;
  getPreviewData: (item: T) => FullscreenVideoPreviewItemData;
  onClose: () => void;
  onNavigate: (item: T) => void;
  onAddToDesign: (item: T) => void;
}

export const SLIDE_VARIANTS = {
  enter: (direction: number): {x: string; opacity: number; filter: string} => ({
    x: direction > 0 ? '115%' : '-115%',
    opacity: 0,
    filter: 'blur(30px)',
  }),
  center: {x: 0, opacity: 1, filter: 'blur(0px)'},
  exit: (direction: number): {x: string; opacity: number; filter: string} => ({
    x: direction > 0 ? '-115%' : '115%',
    opacity: 0,
    filter: 'blur(30px)',
  }),
};

export const SLIDE_TRANSITION = {x: {type: 'tween' as const, duration: 0.3, ease: 'easeOut' as const}, opacity: {duration: 0.2}, filter: {duration: 0.3, ease: 'easeOut' as const}};
